module.exports = {
    NOT_CREATED: 'not_created',
    CREATING: 'creating',
    CREATED: 'created',
    FAILED: 'failed',
};
